// frontend/packs/home.js

/* eslint-disable import/first, import/newline-after-import */

import '../components/home/home-performance.css';
import '../components/home/home-main.css';

import { Application } from 'stimulus';
export const homePage = Application.start(); // eslint-disable-line import/prefer-default-export

import 'components/home/masthead-vectors/masthead-vectors';
import 'components/home/featured-grid/featured-grid';

import 'components/util/load-more-button/load-more-button';

// start split-test: resource_show_modal_view
// Keeping this here, commented out, so it can be uncommented if above split test fails
// import ResourcesGridController from '../components/resources/grid/grid-controller';
// homePage.register('resources-grid', ResourcesGridController);
// end split-test: resource_show_modal_view

import 'components/home/trusted-by-brands/trusted-by-brands';
import 'components/home/why-vecteezy/why-vecteezy';
import 'components/home/creator-community/creator-community';
import 'components/home/creative-path/creative-path';
import 'components/home/unlock-vecteezy/unlock-vecteezy';
import 'components/home/sign-up-free/sign-up-free';
import 'components/home/explore-vectors-photos-videos/explore-vectors-photos-videos';
import 'components/home/users-are-saying/users-are-saying';

import FeaturedGridController from 'components/home/featured-grid/featured-grid-controller';
homePage.register('featured-grid', FeaturedGridController);

import TrendingSearchesController from 'components/search/trending-searches/trending-searches-controller';
homePage.register('trending-searches', TrendingSearchesController);
